import {
    isAppPage,
    isEmbeddedPage,
    isPublicRoute,
    isLoginPage
} from './app/helper/pages';
import bootstrapAngular from './bootstrapAngular';
import { FnwHeightChange, FnwScrollChange } from '@farmnet/webapp-loader-companion';

const app = (window as any).app;

// TODO: Initial loading of moduleinfo is done here
function loadAndStoreModuleInfo() {
    return fetch('/365FarmNet/mod/mms/moduleinfo', {
        credentials: 'same-origin'
    })
    .then(repsonse => repsonse.json())
    .then(moduleInfos => {
        const mappedModuleInfos = moduleInfos.map((module : any) => {
            module.serie = true;

            module.files = module.files.map((filename : string) => {
                return `../mod/${module.name}/${filename}`;
            });

            return module;
        });
        return mappedModuleInfos;
    })
    .then(moduleInfos => {
        app.modules = moduleInfos;
    });
}


fetch('/365FarmNet/rest/credentials?source=bootstrap', {
        credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(data => {
        const isApp = isAppPage();
        const isEmbedded = isEmbeddedPage();
        const isPublic = isPublicRoute();
        const isLogin = isLoginPage();
        const targetPageAfterLogin = window.location.search ? window.location.search : window.location.hash;
        let locale : string;


        init(data);
        main();

        function init(data : any) {
            app.credentials = data;

            if (app.credentials.loggedIn) {
                // server knows better if we are logged in (user might have changed the language at some other browser
                locale = app.credentials.locale;
            } else {
                // else check first the local storage (last stored language) or what the credentials say (browser locale, etc)
                locale = app.languages.current() || app.credentials.locale;
            }

        }

        /*
         * Main
         *
         * Ajax Calls and Handlers
         *
         * ---------------------------------------------------------------------------------------------------
         *
         */
        function main() {
            let promises;

            switch (true) {
                case (!app.credentials.loggedIn && isApp && !isPublic):  // user is not logged in AND is on index.html

                    // redirect to login page now
                    const lastRoute = getTargetPageAfterLogin().substr(1);

                    if (lastRoute && lastRoute.indexOf('/register') > -1) {
                        // TODO: CFNPOC-35725 and CFNPOC-35207
                        // remove redirect from 'index.html#/register' to 'login.html#/registration'
                          window.location.href = `login.html#/registration`;
                    } else {
                        window.location.href = `login.html?requestedRoute=${encodeURIComponent(lastRoute)}`;
                    }

                    break;
                case (app.credentials.loggedIn && isApp):  // user is logged in AND is on index.html

                    // Main preparatory Ajax Calls to receive moduledefinitions (mms) and localization Keys
                    Promise.all([
                        loadAndStoreLanguage(),
                        loadAndStoreModuleInfo()
                    ]).then(onAllCallsLoaded);

                    break;
                case (app.credentials.loggedIn && isEmbedded):  // user is logged in AND is on embedded.html

                    // Main preparatory Ajax Calls to receive moduledefinitions (mms) and localization Keys
                    Promise.all([
                        loadAndStoreLanguage(),
                        loadAndStoreModuleInfo()
                    ]).then(onAllCallsLoaded);

                    break;
                default:  // user is not on index.html or is registering - (whether he is logged in doesn't matter)

                    loadAndStoreLanguage()
                        .then(onAllCallsLoaded);
                    break;
            }
        }

        function loadAndStoreLanguage(): Promise<any> {
            const fetchLocalTranslation = () => {

                return app.languages
                    .fetchLoad(locale)
                    .then((data : any) => {
                            app.translations = prepareTranslations(data);

                            return app.translations;
                        })
                        .catch((error: any) => {
                            // handling the error solves white page relogin issue
                            console.error('error fetching local translation:', error);
                        });
                };

            return fetchLocalTranslation();
        }

        function onAllCallsLoaded() {
            if (isApp) {
                app.transitionhelper.initGeaLegacyModule();
            }

            // APP BOOTSTRAP CALL!
            // this is where the magic happens - full bootstrap of the complete Angular App (Resolving all Dependencies, Compiling View, loading Directives etc.)
            // APP BOOTSTRAP CALL!
            bootstrapAngular(locale)
                .then(() => {
                    app.finishLoading();
                });
        }

        /*
         * Helper functions
         *
         * ---------------------------------------------------------------------------------------------------
         *
         */
        function prepareTranslations(localizeKeysData : any) {
            const tempLocalizeKeysData = Object.entries(localizeKeysData)
                .reduce((object : { [key : string] : string}, [key, value]) => {
                    object[key] = (value as string).replace(/([a-z]?)&shy;([a-z]?)/g, '$1\u00AD$2');

                    return object;
                }, {});

            return tempLocalizeKeysData;
        }


        function getTargetPageAfterLogin() {
            return window.location.search ? window.location.search : window.location.hash;
        }
    })
    .catch((error) => {
        console.error('[bootstrap.ts] Could not connect to credential service => ' + error);
        alert('[bootstrap.ts] Could not connect to credential service => ' + error);
    });
